var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentTracking2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Document_Tracking2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document_Tracking2",
    "data-name": "Document Tracking2",
    clipPath: "url(#clip-Document_Tracking2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(-2.958 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(3.812 3.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M15.817,5.427a1.258,1.258,0,0,0-.842.654.847.847,0,0,0-.106.464.952.952,0,0,0,.042.414l.05.148-.86.736c-.472.4-.878.733-.9.731a1.292,1.292,0,0,1-.211-.077.862.862,0,0,0-.464-.077.774.774,0,0,0-.5.1,1.355,1.355,0,0,0-.346.245l-.14.142-.662-.23-.662-.232V8.329a1.187,1.187,0,1,0-2.332.343c.021.079.042.164.045.187a11,11,0,0,1-.973.9l-.979.857-.156-.077a1.187,1.187,0,0,0-1.039,2.134,1.158,1.158,0,0,0,1.367-.224,1.025,1.025,0,0,0,.343-.773,1.077,1.077,0,0,0-.042-.417L6.4,11.093l.084-.074c.047-.04.491-.427.987-.863l.9-.791.145.071A1.181,1.181,0,0,0,9.879,9.2l.15-.15.657.23.657.232.016.2a1.135,1.135,0,0,0,.319.694,1.167,1.167,0,0,0,1.169.34A1.188,1.188,0,0,0,13.688,9.3c-.021-.079-.042-.164-.045-.19a8.2,8.2,0,0,1,.86-.784l.868-.741.132.069a1.2,1.2,0,0,0,1.712-.847,1.209,1.209,0,0,0-.8-1.345A1.438,1.438,0,0,0,15.817,5.427Zm.522.7a.5.5,0,0,1,.2.216.494.494,0,0,1,0,.5A.548.548,0,0,1,15.5,6.6a.5.5,0,0,1,.169-.4A.54.54,0,0,1,16.339,6.131Zm-7.152,1.7a.616.616,0,0,1,.375.351.554.554,0,1,1-.892-.235A.518.518,0,0,1,9.188,7.833Zm3.561,1.25a.566.566,0,0,1,.348.512.557.557,0,0,1-.968.369.491.491,0,0,1-.135-.425A.54.54,0,0,1,12.749,9.083ZM5.566,11.117a.526.526,0,0,1,.3.5.539.539,0,0,1-.2.43.559.559,0,0,1-.913-.443.69.69,0,0,1,.216-.425A.58.58,0,0,1,5.566,11.117Z",
    transform: "translate(-4.131 -5.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M403.309,137.042a.4.4,0,0,0-.132.113,40.123,40.123,0,0,0-.055,4.5c-.005,2.438,0,4.485.008,4.548a.339.339,0,0,0,.105.206l.087.087h1.163a5.583,5.583,0,0,0,1.242-.04c.169-.087.158.251.158-4.7,0-4.472,0-4.506-.053-4.593-.1-.161-.119-.164-1.338-.164A5.021,5.021,0,0,0,403.309,137.042Zm1.944,4.706v4.115h-1.5v-4.1c0-2.256.008-4.107.018-4.115s.348-.018.752-.018h.733Z",
    transform: "translate(-392.594 -133.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M138.09,216.089l-.09.09v7.2l.058.074c.111.142.137.145,1.314.145s1.2,0,1.314-.145l.058-.074v-3.572c0-3.118-.005-3.582-.04-3.648-.084-.164-.042-.158-1.34-.158h-1.185Zm2.021,3.709v3.166h-1.477v-6.331h1.477Z",
    transform: "translate(-134.468 -210.444)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M271.09,260.089l-.09.09v5.973l.087.087a.339.339,0,0,0,.206.106c.063.008.591.013,1.171.008,1.147-.008,1.134-.008,1.227-.161a16.227,16.227,0,0,0,.053-3.021,27.882,27.882,0,0,0-.04-3.013c-.084-.164-.042-.158-1.34-.158h-1.185Zm2.021,3.089v2.546h-1.477v-5.091h1.477Z",
    transform: "translate(-263.96 -253.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M5.152,344.908c-.158.084-.153.016-.153,2.1,0,1.9,0,1.91.055,1.981.116.148.111.148,1.316.148a4.891,4.891,0,0,0,1.2-.042c.177-.084.169.008.169-2.113s.008-1.992-.158-2.079A16.633,16.633,0,0,0,5.152,344.908ZM7.11,347v1.5H5.632V345.5H7.11Z",
    transform: "translate(-4.976 -335.907)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_21193",
    "data-name": "Path 21193",
    transform: "translate(11.188 4.172)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.489308476448059 7.923917293548584 L 0.3039722442626953 7.848147869110107 L 0.4126035273075104 0.2937613725662231 L 1.33782947063446 0.2937613725662231 L 1.489308476448059 7.923917293548584 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.8811837434768677 2.4824538230896 L 0.8107643723487854 7.379524707794189 L 0.9786167144775391 7.390254020690918 L 0.8811837434768677 2.4824538230896 M -0.08025991916656494 -0.2062387466430664 L 1.828000068664551 -0.2062387466430664 L 2 8.457581520080566 L -0.20281982421875 8.316771507263184 L -0.08025991916656494 -0.2062387466430664 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(7.38 5.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M65.682.106a1.356,1.356,0,0,1,.662.267,1.659,1.659,0,0,1,.241.238,1.288,1.288,0,0,1,.22,1.137,3.5,3.5,0,0,1-.9,1.445,3.051,3.051,0,0,1-.335.312.117.117,0,0,1-.09,0,4.375,4.375,0,0,1-.4-.387,3.421,3.421,0,0,1-.827-1.352A1.293,1.293,0,0,1,64.462.61a1.686,1.686,0,0,1,.226-.226A1.357,1.357,0,0,1,65.682.106ZM65.447.67a.733.733,0,0,0-.232.063.713.713,0,0,0-.36.346c-.133.272.6.891.828,1.1l-.116.151.116-.151a2.461,2.461,0,0,0,.355-.294.687.687,0,0,0,.155-.807.751.751,0,0,0-.658-.415C65.518.664,65.479.667,65.447.67Z",
    transform: "translate(-64.195 -0.097)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_21194",
    "data-name": "Path 21194",
    transform: "translate(8 10)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.306397438049316 6.124082088470459 L 0.3949646949768066 6.124082088470459 L 0.2100107669830322 0.5000022649765015 L 1.306397438049316 0.5000022649765015 L 1.306397438049316 6.124082088470459 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.7267244458198547 1.000002384185791 L 0.8063974380493164 3.422698020935059 L 0.8063974380493164 1.000002384185791 L 0.7267244458198547 1.000002384185791 M -0.3067026138305664 2.384185791015625e-06 L 1.806397438049316 2.384185791015625e-06 L 1.806397438049316 6.624082088470459 L -0.08886253833770752 6.624082088470459 L -0.3067026138305664 2.384185791015625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    transform: "translate(4 13)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_21189",
    "data-name": "Path 21189",
    transform: "translate(11.289 11.152)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.371529579162598 5.099411964416504 L 0.5563579201698303 5.099411964416504 L 0.4268268048763275 0.2587321400642395 L 1.371529579162598 0.2587321400642395 L 1.371529579162598 5.099411964416504 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -0.08673036098480225 -0.2412676811218262 L 1.871529579162598 -0.2412676811218262 L 1.871529579162598 5.599411964416504 L 0.06955957412719727 5.599411964416504 L -0.08673036098480225 -0.2412676811218262 Z",
    stroke: "none",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentTracking2);
export default __webpack_public_path__ + "static/media/DocumentTracking2.3b2193ad77681d2d98e1aaaa8f0577a9.svg";
export { ForwardRef as ReactComponent };